export const getLiveChatUrl = () => {
  const env = process.env.SHOPEE_ENVIRONMENT || 'live';

  let chatUrl = 'https://chatbot.uat.maribank.com.sg';

  if (env.includes('live')) {
    chatUrl = 'https://chatbot.maribank.com.sg';
  }

  return `native:openLiveChatWeb?url=${encodeURIComponent(
    chatUrl + '?from=BankSGHelpCenter',
  )}`;
};
